import React from "react";
import { PickUpStatus } from "gpc-shared-types";
import OrderProgressBar from "./OrderProgressBar";

export type Props = {
  status: PickUpStatus;
};

const PickupProgress = ({ status }: Props) => {
  const currentState =
    status === PickUpStatus.READY_FOR_PICKUP
      ? 1
      : status === PickUpStatus.PICKED_UP
        ? 2
        : 0;

  return (
    <OrderProgressBar
      stateLabels={["Paid", "Ready for pickup", "Picked up"]}
      currentStateIndex={currentState}
    />
  );
};

export default PickupProgress;
